<template>
  <div class="order">
    <div class="p-title">限量广告投放</div>
    <div class="p-main">
      <div class="put_tabs" v-show="!isShowConfirm">
        <span v-for="{ tabType, title } in tabItems" :class="['put_tab_pane', { act: tabType === curTab }]" :key="tabType"
          @click="tabSelect(tabType)">
          {{ title }}
        </span>
      </div>
      <PutOrderMain v-if="showContent" :isExport="isExport" :importType="importType" @showConfirm="(v) => { isShowConfirm = v }"></PutOrderMain>
    </div>
  </div>
</template>

<script>
import PutOrderMain from './main.vue'

/**
 * 小屏相关须带有 smallSn 字样 其他地方可以 获取store order coditionSearchTypeName.toLowerCase indexOf 'smallsn' > -1 判断
 * 导入相关须带有 Import 字样 其他地方可以 获取store order coditionSearchTypeName.toLowerCase indexOf 'import' > -1 判断
 */
const fullTabs = [
  { title: '条件筛选', tabType: 'putOrderTimeLimit' }
,{
  title: '导入小区',
  tabType: 'communityImport'
}, {
  title: '导入点位',
  tabType: 'deviceImport'
},
]

export default {
  name: 'PutOrderTimeLimit',
  components: { PutOrderMain },
  data() {
    return {
      curTab: 'putOrderTimeLimit',
      tabItems: [],
      isShowConfirm: false,
      showContent: true
    }
  },
  watch: {
    '$store.state.customer.userInfo': {
      immediate: true,
      handler(v) {
        if (!v) return
        if ([15595,2002609].indexOf(v.id) > -1) this.tabItems = [fullTabs[0]]
        else this.tabItems = fullTabs
      }
    }
  },
  computed: {
    isExport () {
      return this.curTab.indexOf('Import') > 0
    },
    importType () {
      return this.curTab.replace('Import', '')
    }
  },

  beforeDestroy() {
    this.$store.commit('order/setCoditionSearchType', '') // 还原搜索类型
  },
  created() {
    this.$store.commit('order/setCoditionSearchType', 'putOrderTimeLimit') // 初始设置状态为条件筛选
  },
  methods: {
    tabSelect(tabName) {
      if (tabName === this.curTab) return
      this.curTab = tabName
      this.$store.commit('order/setCoditionSearchType', tabName)
      this.showContent = false
      this.$nextTick(() => {
        this.showContent = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.put_tabs {
  height: 50px;
  padding: 0 10px;
  background-color: #f5f5f5;
  box-shadow: 0 -1px 0 0 #d4d4d4 inset;
}

.put_tab_pane {
  display: inline-block;
  padding: 9px 28px;
  margin-top: 8px;
  margin-left: 10px;
  color: #666666;
  font-size: 16px;
  line-height: 22px;
  background-color: #f5f5f5;
  border: 1px solid #d4d4d4;
  border-radius: 4px 4px 0 0;
  cursor: pointer;

  &:hover {
    color: #000;
  }

  &.act {
    color: #282729;
    background-color: #ffffff;
    border-bottom-color: #fff;
    font-weight: bolder;
  }
}
</style>
